export const GET_CANDIDATES = 'app/InterviewPage/GET_CANDIDATES'
export const GET_CANDIDATES_SUCCESS = 'app/InterviewPage/GET_CANDIDATES_SUCCESS'
export const GET_CANDIDATES_ERROR = 'app/InterviewPage/GET_CANDIDATES_ERROR'
export const CLEAR_MESSAGE = 'app/InterviewPage/CLEAR_MESSAGE'
